import React from "react";
import { Alert, AlertDescription, AlertTitle, AlertIcon, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { qoriaColours } from "@/theme/colours";

interface Props {
	count: number;
	max: number;
}

export function MaxListsReached(props: Props): JSX.Element {
	const { count, max } = props;
	const { t } = useTranslation();

	return (
		<Alert status="error" rounded="lg">
			<AlertIcon boxSize={5} color={qoriaColours.brand.danger[500]} />
			<Box>
				<AlertTitle fontSize="md" fontWeight="bold" color={qoriaColours.brand.danger[500]}>
					{t("rulesLibrary.maxListsReached.title")}
				</AlertTitle>
				<AlertDescription fontSize="md" fontWeight="normal" color={qoriaColours.brand.danger[500]}>
					{t("rulesLibrary.maxListsReached.description", { count, max })}
				</AlertDescription>
			</Box>
		</Alert>
	);
}
